var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('NavBar'),_c('HeadHero'),_c('Profile'),_c('ContactLink'),_c('Experience'),_c('ContactLink'),_c('Portfolio'),_c('ContactLink'),_c('Technologies'),_c('Contact')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }